import { Stack, Typography } from '@mui/material';

import { ApiWorkflowDialog } from '@verantos-dev/shared-components';

import { SearchableSelectList } from '../../components/SearchableSelectList';
import { SelectListItem } from '../../components/SelectListItem';
import { useAddVariablePickerModal } from '../../hooks/useAddVariablePickerModal';
import type { AddVariablePickerModalProps } from '../../types';

export const AddVariablePickerModal = ({ projectId, onClose }: AddVariablePickerModalProps) => {
  const {
    title,
    searchPlaceholder,
    emptyMessage,
    noResultsMessage,
    selectHeading,
    searchQuery,
    onSearchChange,
    options,
    selectedId,
    onSelect,
    onConfirm,
    onCancelClose,
    isLoading,
    canConfirm,
    isSubmitting,
    submitError,
    dialogMessages,
  } = useAddVariablePickerModal({ projectId, onClose });

  return (
    <ApiWorkflowDialog
      id="addVariablePickerModal"
      title={title}
      dialogMessages={dialogMessages}
      onClose={onCancelClose}
      onSubmit={onConfirm}
      onRetrySubmit={onConfirm}
      isValidForSubmit={canConfirm}
      isSubmitting={isSubmitting}
      submittingError={submitError ? { message: submitError.message } : undefined}
    >
      <Typography variant="body1" sx={{ fontWeight: 500, pt: 1 }}>
        {selectHeading}
      </Typography>
      <SearchableSelectList
        searchPlaceholder={searchPlaceholder}
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        isLoading={isLoading}
        emptyMessage={emptyMessage}
        noResultsMessage={noResultsMessage}
        testIds={{
          search: 'add-variable-picker-search',
          loading: 'add-variable-picker-loading',
          empty: 'add-variable-picker-empty',
          noResults: 'add-variable-picker-no-results',
        }}
      >
        {options.map((option) => (
          <SelectListItem
            key={option.analyticalVariableId}
            selected={option.analyticalVariableId === selectedId}
            onSelect={() => onSelect(option.analyticalVariableId)}
            data-testid={`add-variable-picker-row-${option.analyticalVariableId}`}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ flex: 1, minWidth: 0 }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 600, minWidth: 0 }} noWrap>
                {option.title}
              </Typography>
              {option.format && (
                <Typography variant="caption" color="text.secondary">
                  {option.format}
                </Typography>
              )}
            </Stack>
          </SelectListItem>
        ))}
      </SearchableSelectList>
    </ApiWorkflowDialog>
  );
};
